import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-4" }
const _hoisted_2 = { class: "flex flex-row space-x-4" }

import { defineProps } from "vue/dist/vue";
import ModalContainer from "@/components/Modals/ModalContainer.vue";
import PrimaryLabel from "@/components/Form/Common/PrimaryLabel.vue";
import ModalText from "@/components/Texts/ModalText.vue";
import SecondaryButton from "@/components/Form/Common/SecondaryButton.vue";
import PrimaryButton from "@/components/Form/Common/PrimaryButton.vue";
import { useDialogsStore } from "@/Store/useDialogsStore";
import { useGameStore } from "@/Store/useGameStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalStopGame',
  props: {
    dialogId: {}
  },
  setup(__props: any) {

const props = __props;

const dialogsStore = useDialogsStore();
const gameStore = useGameStore();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalContainer, {
    "dialog-id": props.dialogId,
    "out-side-closable": true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(PrimaryLabel, {
          text: "Arrêter la partie en cours",
          class: "mb-2"
        }),
        _createVNode(ModalText, null, {
          default: _withCtx(() => [
            _createTextVNode(" Êtes vous sûre de vouloir arrêter la partie en cours ? ")
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(SecondaryButton, {
            label: "Continuer",
            class: "w-1/2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(dialogsStore).closeAllModals()))
          }),
          _createVNode(PrimaryButton, {
            label: "Arrêter",
            class: "w-1/2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(gameStore).stopAndRestartGame()))
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["dialog-id"]))
}
}

})